// Campos do módulo de autorização (GIY-056): rótulo/dica/erro ligados por id (a11y), seleção nativa estilizada e a
// linha de leitura (`Row`) das fichas — o mesmo desenho do módulo de tenancy.
import type { ReactNode } from 'react';

export interface FieldProps {
  readonly id: string;
  readonly label: string;
  readonly hint?: string | undefined;
  readonly error?: string | undefined;
  readonly children: ReactNode;
}

export function Field({ id, label, hint, error, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-body font-medium">
        {label}
      </label>
      {children}
      {hint && !error && (
        <p id={`${id}-hint`} className="text-caption text-muted-foreground">
          {hint}
        </p>
      )}
      {error && (
        <p id={`${id}-error`} role="alert" className="text-caption text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}

/** Par rótulo/valor de uma ficha (dentro de um `<dl>`). */
export function Row({ label, value }: { readonly label: string; readonly value: ReactNode }) {
  return (
    <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
      <dt className="w-52 shrink-0 text-body text-muted-foreground">{label}</dt>
      <dd className="text-body">{value}</dd>
    </div>
  );
}
